import type { APIMeta } from '@components/organisms/data-grid/hooks/use-api';

const getNavigatorLanguage = () => {
	if (typeof navigator !== 'undefined' && navigator.language) {
		return navigator.language;
	}

	return 'en-US';
};

const getTimeZone = () => {
	if (typeof Intl !== 'undefined' && Intl.DateTimeFormat().resolvedOptions().timeZone) {
		return Intl.DateTimeFormat().resolvedOptions().timeZone;
	}

	return 'America/New_York';
};

export const ACTION_BAR_HEIGHT = 106;
export const ACTION_COLUMN_WIDTH = '40px';
export const DEFAULT_INLINE_ACTION_COLUMN_WIDTH = 120;
export const DEFAULT_ACTION_BAR_ACTION_USABILITY_MESSAGE = 'This action is not available for this row.';
export const DEFAULT_FILTER_GROUP_NO_DATA_MESSAGE = 'No options available.';
export const DEFAULT_FILTER_GROUP_SEARCH_PLACEHOLDER = 'Search';
export const DEFAULT_MAX_ROWS = 20;
export const DEFAULT_LOADING_MESSAGE = 'This may take a few moments, please be patient.';
export const DEFAULT_META: APIMeta = {
	currentPage: 0,
	itemsPerPage: 0,
	totalItems: 0,
	totalPages: 0,
};
export const DEFAULT_NO_DATA_MESSAGE = 'No matching {{subject}} found. Try adjusting your filters or adding a new one.';
export const DEFAULT_OPTIONS = {
	locale: getNavigatorLanguage(),
	timezone: getTimeZone(),
};
export const DEFAULT_PAGE_INDEX = 0;
export const DEFAULT_PAGE_SIZE = 8;
export const DEFAULT_SKELETON_ROW_COUNT = 8;
export const DEFAULT_SORT_COLUMN = 'id';
export const FOOTER_HEIGHT = 52;
export const HEADER_HEIGHT = 28;
export const ROW_BORDER_HEIGHT = 1;
export const PAGE_SIZE_BOTTOM_SPACING = 40;
export const MIN_ROW_HEIGHT = {
	md: 45,
	lg: 65,
} as const;
export const EMPTY_STATE_MIN_HEIGHT_PX = `${HEADER_HEIGHT + MIN_ROW_HEIGHT.md}px`;
/**
 * Checkbox is h-5/w-5 (2.4rem = 24px at the 10px rem root) and first-cell padding is
 * pl-2 + pr-2 (1.2rem each = 24px). 40px was too narrow and overflow:hidden clipped the control.
 */
export const SELECTION_COLUMN_WIDTH_PX = 56;
export const SELECTION_COLUMN_WIDTH = `${SELECTION_COLUMN_WIDTH_PX}px`;
export const DEFAULT_CLEAR_FILTERS_LABEL = 'Clear Filters';
export const DEFAULT_SEARCH_PLACEHOLDER = 'Search';
/** Collapses the burst of state changes around a filter/sort/page change into one request. */
export const FETCH_DEBOUNCE_MS = 200;
/** Collapses a window resize into one page-size update. */
export const PAGE_SIZE_SYNC_DEBOUNCE_MS = 200;
/** Delay before a typed search term is committed, so each keystroke is not a request. */
export const SEARCH_DEBOUNCE_MS = 200;
export const DEFAULT_TEXT_LIST_MORE_TEXT = (count: number) => `+${count} more`;
